import { render, staticRenderFns } from "./almondco-inshell-lot-allocation-history-popup.vue?vue&type=template&id=455135b6"
import script from "./almondco-inshell-lot-allocation-history-popup.vue?vue&type=script&lang=js"
export * from "./almondco-inshell-lot-allocation-history-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports